import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';

export default class Page extends React.Component {
	render() {
		return (
			<DocumentTitle title="E-mailové layouty">
				<TabbablePage
					module="emaillayout"
					List={List}
					Form={Form}
					newTitle="Nový"
					listTitle="Seznam layoutů"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Emaillayout/Page.js